// extracted by mini-css-extract-plugin
export default {"container":"InlineAutocomplete-module__container--UwGMb","fullWidth":"InlineAutocomplete-module__fullWidth--X6eXo"};